// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag_tag__1Lj8e","danger":"tag_danger__1BOh7","warning":"tag_warning__lw4XU","primary":"tag_primary__1sKch","info":"tag_info__3V9Iu","success":"tag_success__2jhbE"};